'use strict'

module.exports = bail

function bail(err) {
  if (err) {
    throw err
  }
}



//////////////////
// WEBPACK FOOTER
// ./~/bail/index.js
// module id = 266
// module chunks = 230186691558513